export default {
  primary50: '#F0F9FF',
  primary100: '#E0F2FE',
  primary200: '#BAE6FD',
  primary300: '#7DD3FC',
  primary400: '#38BDF8',
  primary500: '#0EA5E9',
  primary600: '#0284C7',
  primary700: '#0369A1',
  primary800: '#075985',
  primary900: '#083853',
  secondary50: '#F5F3FF',
  secondary100: '#EDE9FE',
  secondary200: '#DDD6FE',
  secondary300: '#C4B5FD',
  secondary400: '#A78BFA',
  secondary500: '#8B5CF6',
  secondary600: '#7C3AED',
  secondary700: '#6D28D9',
  secondary800: '#541EAA',
  secondary900: '#3C137B',
  white: '#ffffff',
  grey50: '#FAFAFA',
  grey100: '#F4F4F5',
  grey200: '#E4E4E7',
  grey300: '#D4D4D8',
  grey400: '#A1A1AA',
  grey500: '#71717A',
  grey600: '#52525B',
  grey700: '#3F3F46',
  grey800: '#27272A',
  grey900: '#18181B',
  warning50: '#FEFCE8',
  warning100: '#FEF08A',
  warning300: '#FACC15',
  warning600: '#CA8A04',
  warning800: '#713F12',
  success50: '#F0FDF4',
  success100: '#BBF7D0',
  success300: '#4ADE80',
  success600: '#16A34A',
  success800: '#14532D',
  error50: '#FEF2F2',
  error100: '#FEE2E2',
  error300: '#F87171',
  error600: '#DC2626',
  error800: '#7F1D1D',
  transparent: 'rgba(255, 255, 255, 0);',
} as const;
